import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';
import {GlobalFunction} from '../core/global_function';


@Injectable()
export class MentorService extends ServiceGlobal {

    first_name: string;
    last_name: string;
    display_name: string;
    full_name_zh: any;
    gender: any;
    code: string;
    school: any;
    expiry_date: any;
    remarks: any;
    profile_image: any;
    username: string;
    role: number;
    active: boolean;

    name_alpha: any = 'display_name';
    api_find_all: any = 'mentor_list';
    api_find_one: any = 'mentors';
    api_delete: any = 'mentors';
    loading: any = false;
    primary_key: any = 'username';
    tableName() { return 'mentor'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "first_name": "First Name",
            "last_name": "Last Name",
            "display_name": "School Name",
            "full_name_zh": "Chinese Name",
            "gender": "Gender",
            "code": "Short Code",
            "student_count": "Student",
            "school": "Assigned School",
            "expiry_date": "Expiry Date",
            "remarks": "Remarks",
            "profile_image": "Profile picture",
            "username": "Email",
            "role": "Role",
            "active": "Active"
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "username" : {
                "type": "string",
                "require": {
                    "empty": true,
                    "size": 100,
                    "email": true,
                },
            },
            "first_name": {
                "type": "string",
                "require": {
                    "empty": true,
                    "size": 100,
                },
            },
            "last_name": {
                "type": "string",
                "require": {
                    "empty": true,
                    "size": 100,
                },
            },
            "display_name":  {
                "type":"any",
                'search': {
                    'op'    : 'like',
                    'value' : '%{value}%',
                }
            },
            "full_name_zh": {
                "type":"any"
            },
            "gender": {
                "type":"any"
            },
            "code": {
                "type": "string",
                "require": {
                    "empty": true,
                    "size": 100,
                },
            },
            "school":  {
                "type":"any",
                "require": {
                  "correlateEmpty": {"correlateEqual": false,
                                     "correlateItem": {value: "role", label: "Role"},
                                     "correlateValue": [{value: 1, label: 'Super Admin'},{value: 2, label: 'System Admin'}]
                                    },
                },
                'search': true,
            },
            "expiry_date":  {
                "type":"any",
                'search': true,
                "require": {
                  "date": true,
                },
            },
            "remarks":  {
                "type":"any"
            },
            "profile_image":  {
                "type":"any",
            },
            "role":  {
                "type":"any",
                "require": {
                    "empty": true,
                    "size": 20,
                },
                'search': true
            },
            "active": {
                "type": "boolean",
                'search': true
            }
        });
    }

    save(update=false) {
        var link = API.CREATE_MENTOR;
        let attrs = update ? this.getAttributesUpdate() : this.getAttributes();
        if (attrs && attrs['expiry_date']) {
            attrs['expiry_date'] = GlobalFunction.convertInputDateYMDToMilliseconds(attrs['expiry_date']);
        }
        var role = attrs['role'];
        if (typeof role == 'string' && !isNaN(role as any)) {
            var roleId = parseFloat(role);
            if (!isNaN(roleId)) {
                role = roleId;
                attrs['role'] = roleId;
            }
        }
        if (update) {
            if (role == 1 || role == 2 ){
                attrs['school'] = null;
            }
            if (!attrs['expiry_date']) {
              attrs['expiry_date'] = undefined;
            }
            if (!attrs['profile_image']) {
              attrs['profile_image'] = undefined;
            }
            link += '/' + this.username;
        } else {
            if (attrs['active'] == null) {
                // create active mentor by default
                attrs['active'] = true;
            }
        }
        return this._db.post(link, attrs);
    }

    forgotPwd(email) {
      let api = API.FORGOTPASSWORD;
      let attributes = this.getAttributesNotEmpty();
      if(email) {
        console.log(email.trim());
        api = api.replace('{email_address}', email.trim());
        return this._db.getWithClientCredentialAuth(api).then(res => {
          return Promise.resolve(res);
        });
      }
    }
    async getAvatarUserLogin(id: any) {
      return await this._db.get(API.GET_FILES +'/'+ id);
    }

    async getMentorList() {
      return await this._db.getCsv(API.GET_MENTOR_LIST);
    }

    active_inactive(email, type) {
      let link = API.GET_MENTOR.replace('{email_address}', email.trim());;
      return this._db.put(link, {active: type});
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/mentor.service.ts